<template lang="html">
  <div v-if="platform !== 'notInDingTalk'"></div>
    <div v-else class="model" @click="closeModel">
      <swiper class="swiper-container" ref="mySwiper" :options="swiperOptions">
        <swiper-slide v-for="item in imgs" :key="item.id">
          <img v-lazy="`${item.url}`"/>
        </swiper-slide>
      </swiper>
    </div>
</template>
<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import dd from 'DD'
import { previewImage } from '../utils/ddUser'
export default {
  components: {
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  props: {
    imgs: {
      type: Array,
      default: () => {
        return []
      }
    },
    initialIndex: {
      type: Number,
      default: 0
    }
  },
  mounted () {
    let { imgs } = this
    imgs = imgs.map(item => item.url)
    previewImage(imgs, this.initialIndex, () => {
      this.swiper.slideTo(this.initialIndex, 1000, false)
    })
  },
  data () {
    return {
      platform: dd.env.platform,
      height: window.innerHeight,
      width: document.body.clientWidth,
      initialIndex1: 0,
      swiperOptions: {
        zoom: {
          toggle: false
        }
        // Some Swiper option/callback...
      }
    }
  },
  methods: {
    closeModel (e) {
      e.preventDefault()
      e.stopPropagation()
      this.$emit('click')
    }
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.$swiper
    }
  }
}
</script>
<style lang="scss" scoped>
.model {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: calc(100% - 50px);
  z-index: 999;
  background: rgba(0, 0, 0, 1);
  box-sizing: border-box;
  display: flex;
  align-items: center;
  .swiper-container {
    width: 100%;
    height: 100%;
    .swiper-slide {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      img {
        display: block;
        max-width: 100vw;
        max-height: calc(100vh - 50px);
        height: auto;
        margin: 0 auto;
        max-height: 100%;
      }
    }
  }
}
</style>
